import { injectable } from "inversify";
import "reflect-metadata";
import FinanceiroGatewayAdapter from "./financeiro/FinanceiroGatewayAdapter";
import { IHorizonsGateway } from "../ports/HorizonsGateway";

@injectable()
export default class HorizonsGatewayAdapter
  extends FinanceiroGatewayAdapter
  implements IHorizonsGateway {}
